function formatCpf(cpf) {
  let newCpf = cpf;

  if (typeof cpf !== 'string') {
    newCpf = cpf.toString();
  }

  if (!newCpf || newCpf.length !== 11) {
    return newCpf;
  }

  return `${newCpf.substr(0, 3)}.${newCpf.substr(3, 3)}.${newCpf.substr(6, 3)}-${newCpf.substr(9)}`;
}

export default formatCpf;
